<script lang="ts">
  import { fly } from "svelte/transition";

  export let label: string = "";
  export let id: string = "";
  export let required: boolean = false;
  export let error: string | undefined = undefined;
</script>

<label for={id} class="block" on:mousedown>
  {#if label}
    <div class="relative mb-1 flex items-center justify-between">
      <div class="pointer-events-none absolute inset-0 flex items-center">
        <slot name="background" />
      </div>
      <span class="font-mediumn relative block align-middle text-12 text-nxgray-600">
        {label}
        <slot name="after-label" />
        {#if !required}
          <span class="text-12 font-normal text-secondary">(optional)</span>
        {:else}
          <span class="text-sm text-danger-600">*</span>
          <slot name="after-required" />
        {/if}
      </span>

      <div class="relative flex items-center">
        {#if error}
          <span class="text-xs text-danger-600" transition:fly|local={{ duration: 150, y: 10 }}>{error}</span>
        {/if}
        <slot name="right" />
      </div>
    </div>
  {/if}
  <slot />
</label>
